import axios from "api/axios.js";

let isMounted = true;
const controller = new AbortController();
const clientsUrl = "/clients";
export async function getClients() {
  try {
    const response = await axios.get(clientsUrl, {
      signal: controller.signal,
    });
    return response.data;
  } catch (err) {
    console.error(err);
  }
  return () => {
    isMounted = false;
    controller.abort();
  };
}
